export const translations = {
  ua: {
    // Navigation
    nav: {
      home: 'Головна',
      about: 'Про компанію',
      solutions: 'Рішення PURA',
      products: 'Продукти',
      partners: 'Партнерам',
      contacts: 'Контакти'
    },
    
    // Hero Section
    hero: {
      title: 'Європейські рішення для чистої України',
      subtitle: 'Офіційний постачальник європейських рішень для водопостачання та очистки стічних вод. Сертифіковані системи біологічної очистки PURA для приватних будинків та комерційних об\'єктів.',
      consultation: 'Отримати консультацію',
      viewProducts: 'Переглянути продукцію',
      years: 'Років гарантійного обслуговування',
      cleaning: 'Очищення стоків',
      exploitation: 'Років експлуатації',
      officialRep: 'Офіційний представник Plastic Technology'
    },
    
    // Video Section
    video: {
      title: 'Виробництво PURA',
      subtitle: 'Дізнайтесь більше про виробничий процес та технології Plastic Technology'
    },
    
    // Advantages
    advantages: {
      title: 'Чому обирають PURA Ukraine',
      subtitle: 'Поєднуємо європейську якість з розумінням українських реалій'
    },
    
    // Products
    products: {
      title: 'Наша продукція',
      subtitle: 'Комплексні рішення для водопостачання та водовідведення',
      viewAll: 'Переглянути всі рішення PURA',
      learnMore: 'Дізнатися більше'
    },
    
    // PURA Details
    puraDetails: {
      stationTitle: 'Станція біологічної очистки PURA',
      stationDesc1: 'Станція біологічної очистки стічних вод PURA, розрахована на обслуговування до 50 мешканців. Вона відноситься до заводських, пакетних очисних споруд, які ставляться готовим блоком і підходять для котеджних містечок, готелів, баз відпочинку, невеликих житлових комплексів та інших об\'єктів із подібним навантаженням.',
      stationDesc2: 'Особливістю PURA є використання аераційної біологічної очистки з інтенсивним перемішуванням стічних вод повітрям, що забезпечує рівномірну роботу камер та ефективне видалення забруднень перед скиданням у ґрунт або водойму згідно європейських вимог.',
      individualTitle: 'Індивідуальний підхід',
      individualDesc1: 'Індивідуальні пластикові вироби за кресленнями та технічними вимогами замовника, адаптуючи конструкцію під конкретні умови монтажу й функції. Створюємо нестандартні ємності з потрібними розмірами, формою та комплектацією.',
      individualDesc2: 'Устаткування проєктується після аналізу реальних умов на об\'єкті: ми збираємо фактичні дані по стоках, режиму роботи та вимогах до очищення й на їх основі виконуємо технологічні розрахунки.',
      individualDesc3: 'Для виготовлення використовуємо високоякісний поліпропілен (PP) або поліетилен (PE), які мають високу міцність і стійкість до корозії та хімічного впливу.'
    },
    
    // CTA
    cta: {
      title: 'Оберіть Plastic Technology – оберіть надійність, перевірену ЄС',
      subtitle: 'Забезпечте своєму дому чисту воду та екологічне майбутнє разом з ексклюзивним постачальником ТОВ "ПУРА УКРАЇНА"',
      contact: 'Зв\'язатися з нами',
      becomePartner: 'Стати партнером'
    },
    
    // About Page
    about: {
      title: 'Про PURA Ukraine',
      desc1: 'Ми – офіційний постачальник європейських рішень для водопостачання та очистки стічних вод, а також нестандартних пластикових резервуарів для приватних будинків, котеджних містечок і бізнесу. За понад 10 років роботи команда зосередилась на практичних інженерних рішеннях і сьогодні пропонує сучасні комплексні очисні споруди «PURA» для об\'єктів до 50 мешканців.',
      desc2: 'Ми беремо на себе весь цикл: від індивідуального підбору та проєктування до виробництва, логістики й технічної підтримки на об\'єкті. Злагоджена робота інженерів і виробничого персоналу забезпечує надійний результат і дотримання європейських стандартів якості водопідготовки та водовідведення.',
      desc3: 'Рішення PURA вже працюють у різних країнах Європи, що підтверджує їхню ефективність і довговічність, а ми робимо ці технології доступними для українських клієнтів.',
      ourAdvantages: 'Наші переваги',
      advantagesSubtitle: 'Що робить нас надійним партнером для вашого проєкту',
      adaptationTitle: 'Адаптація до українських умов',
      adaptationDesc: 'Ми розуміємо, що українські реалії мають свою специфіку. Тому всі наші рішення адаптовані з урахуванням:',
      ourValues: 'Наші цінності',
      valuesDesc: 'Принципи, якими ми керуємося у роботі',
      yearsExperience: 'Років досвіду виробника',
      yearsWarranty: 'Років гарантійного обслуговування',
      yearsService: 'Років служби обладнання',
      cleaningDegree: 'Ступінь очищення стоків'
    },
    
    // Products Page  
    productPage: {
      title: 'Наші рішення PURA',
      subtitle: 'Наші рішення PURA створені для повного циклу очистки побутових стоків – від приватних будинків до комерційних об\'єктів. Компактні, енергоефективні установки для 4–50 осіб, які забезпечують стабільну роботу та не потребують складного обслуговування.',
      allSolutions: 'Всі рішення',
      forPrivateHouses: 'Для приватних будинків',
      forCommercial: 'Для комерційних об\'єктів',
      customProducts: 'Нестандартні вироби',
      specifications: 'Технічні характеристики',
      featuresAndBenefits: 'Переваги та особливості',
      applications: 'Сфери застосування',
      requestPrice: 'Запитати ціну та наявність',
      needHelp: 'Потрібна допомога у виборі?',
      helpDesc: 'Наші фахівці допоможуть підібрати оптимальне рішення для вашого об\'єкта',
      freeConsultation: 'Безкоштовна консультація',
      viewProjects: 'Переглянути реалізовані проєкти'
    },
    
    // Gallery/Custom Products Page
    gallery: {
      title: 'Нестандартні пластикові вироби',
      subtitle: 'Під замовлення можемо виготовити нестандартні пластикові вироби за індивідуальними потребами та кресленнями замовника, адаптуючи конструкцію під конкретні умови роботи й необхідні функції. Створюємо ємності та пристрої, що відповідають навіть найскладнішим вимогам до розміру, форми й комплектації, причому проєктування завжди базується на аналізі реальної ситуації на об\'єкті.',
      individualDesign: 'Індивідуальний дизайн',
      individualDesignDesc: 'Устаткування проєктується після аналізу реальних умов на об\'єкті: ми збираємо фактичні дані по стоках, режиму роботи та вимогах до очищення й на їх основі виконуємо технологічні розрахунки.',
      productionSpec: 'Специфіка виробництва',
      productionSpecDesc: 'Можемо виготовити обладнання в різних формах, розмірах і з потрібним набором функцій, щоб воно відповідало навіть найскладнішим вимогам замовника та ідеально підходило під конкретний об\'єкт.',
      materials: 'Матеріали',
      materialsDesc: 'Використовуємо високоякісний поліпропілен (PP) або поліетилен (PE), які мають високу міцність і стійкість до корозії та хімічного впливу. Обладнання служить довго та безпечно працює у складних умовах.',
      needCustom: 'Потрібен нестандартний виріб?',
      needCustomDesc: 'Звертайтесь до нас з вашими кресленнями та технічними вимогами. Ми створимо рішення, яке ідеально підійде для вашого об\'єкту.'
    },
    
    // Partners Page
    partners: {
      title: 'Станьте нашим партнером',
      subtitle: 'Запрошуємо до ексклюзивної співпраці інсталяторів, проєктантів, девелоперів та власників бізнесу. Пропонуємо технічну підтримку, навчання й вигідні комерційні умови.',
      benefitsTitle: 'Переваги партнерства',
      benefitsSubtitle: 'Що ви отримаєте, працюючи з PURA Ukraine',
      whoWeLookFor: 'Кого ми шукаємо',
      whoWeDesc: 'Ми зацікавлені в співпраці з',
      applicationTitle: 'Заявка на партнерство',
      applicationDesc: 'Заповніть форму, і ми зв\'яжемося з вами для обговорення умов співпраці',
      companyName: 'Назва компанії',
      contactPerson: 'Контактна особа',
      phone: 'Телефон',
      email: 'Email',
      businessType: 'Тип бізнесу',
      city: 'Місто',
      experience: 'Досвід роботи',
      message: 'Повідомлення',
      selectType: 'Оберіть тип',
      installer: 'Монтажна організація',
      designer: 'Проєктне бюро',
      developer: 'Девелопер',
      distributor: 'Дистриб\'ютор',
      construction: 'Будівельна компанія',
      service: 'Сервісний центр',
      other: 'Інше',
      submitApp: 'Відправити заявку',
      required: '*'
    },
    
    // Contacts Page
    contacts: {
      title: 'Зв\'язатися з нами',
      subtitle: 'Маєте питання чи хочете отримати консультацію? Зв\'яжіться з нами у зручний для вас спосіб.',
      contactInfo: 'Контактна інформація',
      contactForm: 'Форма зворотного зв\'язку',
      name: 'Ім\'я',
      phone: 'Телефон',
      email: 'Email',
      subject: 'Тема звернення',
      message: 'Повідомлення',
      send: 'Відправити повідомлення',
      address: 'Адреса',
      workingHours: 'Графік роботи',
      faqTitle: 'Часті питання',
      faqSubtitle: 'Відповіді на найпоширеніші питання',
      notFound: 'Не знайшли відповідь?',
      notFoundDesc: 'Зателефонуйте нам, і ми з радістю відповімо на всі ваші питання'
    },
    
    // Footer
    footer: {
      description: 'Офіційний постачальник європейських рішень для водопостачання та очистки стічних вод. Сертифіковані системи PURA для чистої України.',
      quickLinks: 'Швидкі посилання',
      ourProducts: 'Наша продукція',
      contacts: 'Контакти',
      workingHours: 'Пн-Пт: 9:00 - 18:00',
      copyright: 'ТОВ "PURA УКРАЇНА". Офіційний постачальник рішень Plastic Technology. Усі права захищені.'
    },
    
    // Common
    common: {
      readMore: 'Детальніше',
      viewAll: 'Переглянути всі',
      contactUs: 'Зв\'язатися з нами',
      learnMore: 'Дізнатися більше',
      submit: 'Відправити',
      close: 'Закрити'
    }
  },
  
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About Us',
      solutions: 'PURA Solutions',
      products: 'Products',
      partners: 'Partners',
      contacts: 'Contacts'
    },
    
    // Hero Section
    hero: {
      title: 'European Solutions for Clean Ukraine',
      subtitle: 'Official supplier of European solutions for water supply and wastewater treatment. Certified PURA biological treatment systems for private homes and commercial facilities.',
      consultation: 'Get Consultation',
      viewProducts: 'View Products',
      years: 'Years of Warranty Service',
      cleaning: 'Wastewater Treatment',
      exploitation: 'Years of Operation',
      officialRep: 'Official Representative of Plastic Technology'
    },
    
    // Video Section
    video: {
      title: 'PURA Production',
      subtitle: 'Learn more about the production process and Plastic Technology technologies'
    },
    
    // Advantages
    advantages: {
      title: 'Why Choose PURA Ukraine',
      subtitle: 'We combine European quality with understanding of Ukrainian realities'
    },
    
    // Products
    products: {
      title: 'Our Products',
      subtitle: 'Comprehensive solutions for water supply and wastewater management',
      viewAll: 'View All PURA Solutions',
      learnMore: 'Learn More'
    },
    
    // PURA Details
    puraDetails: {
      stationTitle: 'PURA Biological Treatment Station',
      stationDesc1: 'PURA wastewater biological treatment station, designed to serve up to 50 residents. It belongs to factory-made, packaged treatment plants that are installed as a complete block and are suitable for residential communities, hotels, recreation centers, small residential complexes and other facilities with similar load.',
      stationDesc2: 'A distinctive feature of PURA is the use of aeration biological treatment with intensive mixing of wastewater with air, which ensures uniform operation of chambers and effective removal of contaminants before discharge into the ground or reservoir according to European requirements.',
      individualTitle: 'Individual Approach',
      individualDesc1: 'Custom plastic products according to drawings and technical requirements of the customer, adapting the design to specific installation conditions and functions. We create custom tanks with the required dimensions, shape and equipment.',
      individualDesc2: 'Equipment is designed after analyzing real conditions at the facility: we collect actual data on wastewater, operating mode and treatment requirements and perform technological calculations based on them.',
      individualDesc3: 'For manufacturing, we use high-quality polypropylene (PP) or polyethylene (PE), which have high strength and resistance to corrosion and chemical effects.'
    },
    
    // CTA
    cta: {
      title: 'Choose Plastic Technology – Choose Reliability Verified by the EU',
      subtitle: 'Ensure clean water and an ecological future for your home with the exclusive supplier PURA UKRAINE LLC',
      contact: 'Contact Us',
      becomePartner: 'Become a Partner'
    },
    
    // About Page
    about: {
      title: 'About PURA Ukraine',
      desc1: 'We are an official supplier of European solutions for water supply and wastewater treatment, as well as custom plastic tanks for private homes, residential communities and businesses. Over 10 years of work, the team has focused on practical engineering solutions and today offers modern comprehensive PURA treatment facilities for facilities up to 50 residents.',
      desc2: 'We take on the entire cycle: from individual selection and design to production, logistics and technical support at the facility. The coordinated work of engineers and production personnel ensures reliable results and compliance with European standards of water treatment and wastewater management.',
      desc3: 'PURA solutions are already operating in various European countries, confirming their effectiveness and durability, and we make these technologies available to Ukrainian customers.',
      ourAdvantages: 'Our Advantages',
      advantagesSubtitle: 'What makes us a reliable partner for your project',
      adaptationTitle: 'Adaptation to Ukrainian Conditions',
      adaptationDesc: 'We understand that Ukrainian realities have their own specifics. Therefore, all our solutions are adapted taking into account:',
      ourValues: 'Our Values',
      valuesDesc: 'Principles we follow in our work',
      yearsExperience: 'Years of manufacturer experience',
      yearsWarranty: 'Years of Warranty Service',
      yearsService: 'Years of equipment service',
      cleaningDegree: 'Degree of wastewater treatment'
    },
    
    // Products Page
    productPage: {
      title: 'Our PURA Solutions',
      subtitle: 'Our PURA solutions are designed for the complete cycle of domestic wastewater treatment - from private homes to commercial facilities. Compact, energy-efficient units for 4-50 people that provide stable operation and do not require complex maintenance.',
      allSolutions: 'All Solutions',
      forPrivateHouses: 'For Private Houses',
      forCommercial: 'For Commercial Facilities',
      customProducts: 'Custom Products',
      specifications: 'Technical Specifications',
      featuresAndBenefits: 'Features and Benefits',
      applications: 'Applications',
      requestPrice: 'Request Price and Availability',
      needHelp: 'Need Help Choosing?',
      helpDesc: 'Our specialists will help you choose the optimal solution for your facility',
      freeConsultation: 'Free Consultation',
      viewProjects: 'View Completed Projects'
    },
    
    // Gallery/Custom Products Page
    gallery: {
      title: 'Custom Plastic Products',
      subtitle: 'We can manufacture custom plastic products according to individual needs and customer drawings, adapting the design to specific operating conditions and required functions. We create tanks and devices that meet even the most complex requirements for size, shape and equipment, and the design is always based on analysis of the real situation at the facility.',
      individualDesign: 'Individual Design',
      individualDesignDesc: 'Equipment is designed after analyzing real conditions at the facility: we collect actual data on wastewater, operating mode and treatment requirements and perform technological calculations based on them.',
      productionSpec: 'Production Specifics',
      productionSpecDesc: 'We can manufacture equipment in various shapes, sizes and with the required set of functions to meet even the most complex customer requirements and perfectly suit a specific facility.',
      materials: 'Materials',
      materialsDesc: 'We use high-quality polypropylene (PP) or polyethylene (PE), which have high strength and resistance to corrosion and chemical effects. The equipment serves for a long time and operates safely in complex conditions.',
      needCustom: 'Need a Custom Product?',
      needCustomDesc: 'Contact us with your drawings and technical requirements. We will create a solution that will perfectly suit your facility.'
    },
    
    // Partners Page
    partners: {
      title: 'Become Our Partner',
      subtitle: 'We invite installers, designers, developers and business owners to exclusive cooperation. We offer technical support, training and favorable commercial conditions.',
      benefitsTitle: 'Partnership Benefits',
      benefitsSubtitle: 'What you get working with PURA Ukraine',
      whoWeLookFor: 'Who We Are Looking For',
      whoWeDesc: 'We are interested in cooperation with',
      applicationTitle: 'Partnership Application',
      applicationDesc: 'Fill out the form and we will contact you to discuss cooperation terms',
      companyName: 'Company Name',
      contactPerson: 'Contact Person',
      phone: 'Phone',
      email: 'Email',
      businessType: 'Business Type',
      city: 'City',
      experience: 'Work Experience',
      message: 'Message',
      selectType: 'Select Type',
      installer: 'Installation Company',
      designer: 'Design Bureau',
      developer: 'Developer',
      distributor: 'Distributor',
      construction: 'Construction Company',
      service: 'Service Center',
      other: 'Other',
      submitApp: 'Submit Application',
      required: '*'
    },
    
    // Contacts Page
    contacts: {
      title: 'Contact Us',
      subtitle: 'Have questions or want to get a consultation? Contact us in a convenient way.',
      contactInfo: 'Contact Information',
      contactForm: 'Contact Form',
      name: 'Name',
      phone: 'Phone',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
      send: 'Send Message',
      address: 'Address',
      workingHours: 'Working Hours',
      faqTitle: 'Frequently Asked Questions',
      faqSubtitle: 'Answers to the most common questions',
      notFound: 'Didn\'t Find an Answer?',
      notFoundDesc: 'Call us and we will be happy to answer all your questions'
    },
    
    // Footer
    footer: {
      description: 'Official supplier of European solutions for water supply and wastewater treatment. Certified PURA systems for clean Ukraine.',
      quickLinks: 'Quick Links',
      ourProducts: 'Our Products',
      contacts: 'Contacts',
      workingHours: 'Mon-Fri: 9:00 - 18:00',
      copyright: 'PURA UKRAINE LLC. Official supplier of Plastic Technology solutions. All rights reserved.'
    },
    
    // Common
    common: {
      readMore: 'Read More',
      viewAll: 'View All',
      contactUs: 'Contact Us',
      learnMore: 'Learn More',
      submit: 'Submit',
      close: 'Close'
    }
  }
};
